import script from "./toggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./toggle.vue?vue&type=script&setup=true&lang=ts"

import "./toggle.vue?vue&type=style&index=0&id=28626678&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28626678"]])

export default __exports__